import { defaultFirmaSanktionFieldColumns } from "../../../../../config/firmaConfig";
import { FirmaSanktionerForm } from "../../../../../config/form/firma/firmaSanktionerFormConfig";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../person/id/OpretNyButtonBlock";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import { FirmaDto } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { orderBy } from "../../../../../util/orderBy";

export default function FirmaSanktioner({
  firma,
  invalidateData,
  firmaSanktion,
}: {
  firma: FirmaDto;
  invalidateData: InvalidateDataFunction<any>;
  firmaSanktion: FirmaDto["firmaSanktion"];
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "DisciplinaertWrite");
  const [firmaSanktionerColumns, setFirmaSanktionerActiveColumns] =
    useActiveColumns(
      "firma-firmasanktioner-active-columns",
      defaultFirmaSanktionFieldColumns,
    );

  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "firmaSanktionerSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  if (firmaSanktion?.length === 0) {
    return (
      <IngenRegistreringer
        invalidateData={invalidateData}
        editConfig={canWrite ? FirmaSanktionerForm(firma.id) : undefined}
      />
    );
  }
  return (
    <ModalProvider>
      <TableRoot>
        <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
          <>
            {getHeaderActiveColumns(firmaSanktionerColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        </TableHead>
        <TableBody>
          {orderBy(
            firmaSanktion ?? [],
            sortBy.map((s) => s.field),
            sortBy.map((s) => s.direction),
          ).map((sanktion, i) => {
            return (
              <TableRow
                key={i}
                editConfig={
                  canWrite
                    ? FirmaSanktionerForm(firma.id, sanktion.id)
                    : undefined
                }
                invalidateData={invalidateData}
              >
                <>
                  {firmaSanktionerColumns
                    .filter((col) => col.active)
                    .map((col) => {
                      return (
                        <TD key={col.field} col={col} rowData={sanktion} />
                      );
                    })}
                </>
              </TableRow>
            );
          })}
        </TableBody>
      </TableRoot>
      <ColumnEditorModal
        defaultColumns={defaultFirmaSanktionFieldColumns}
        columns={firmaSanktionerColumns}
        setActiveColumns={setFirmaSanktionerActiveColumns}
      />
      <OpretNyButtonBlock
        editConfig={canWrite ? FirmaSanktionerForm(firma.id) : undefined}
        invalidateData={invalidateData}
      />
    </ModalProvider>
  );
}

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "kendelsesDato",
  },
];
